module.exports = __webpack_public_path__ + "static/media/Guitar-1.0d8471fa.jpg";